import { useState, useEffect } from "react";
import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";


const useOptionsABSelect = (option) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      if (localStorage.getItem(option) !== null) {
        setData(JSON.parse(localStorage.getItem(option)));
      } else {
        let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
        const requestData = {
          token: userLocalData.id,
          param: option,
        };
        const headers = {
          "Content-Type": "application/json",
          Username: "ibridge",
          Password: "ibridge@2020",
        };

        const { data } = await axios.post(
          FOLDERPATH + "/GenericApi/masterData",
          requestData,
          {
            headers: headers,
          }
        );

        let optionsFormat = [];

        console.log(typeof data.data);
        if(option == 'master_ts_university'){
          Object.entries(data.data).forEach((element, index) => {
            // const [key, value] = element;
            optionsFormat.push({
              label:element[1].org_name,
              value:element[1]
            });
          });
          console.log(optionsFormat);
          // optionsFormat.push(data.data);
        }else{ 
          Object.entries(data.data).forEach((element, index) => {
            const [key, value] = element;
            optionsFormat.push({
              value: key,
              label: value
            });
          });
        }


        localStorage.setItem(option, JSON.stringify(optionsFormat));
        setData(optionsFormat);
      }
    } catch (error) {
      setError(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, error, loading };
};

export default useOptionsABSelect;
